import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import SeventhPageStore from '@src/pages/main/components/seventh-page/store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';

/**
 * seventhPage
 * @param store {SeventhPageStore}
 * @returns {JSX.Element}
 * @constructor
 */
const SeventhPage = ({ store }) => {
  const { layerData, localData } = store;
  store.use();
  const containerRef = React.useRef();
  const renderPaginator = () => {
    return layerData.worldViewList.map((item, key) => {
      return (
        <Link
          className={cx(styles.paginatorItem, key === store.baseSwiperStore.activeIndex && styles.paginatorItemActive)}
          onClick={() => store.baseSwiperStore.onChange(key)}
          key={key}
        />
      );
    });
  };
  const getNextTitle = () => {
    setTimeout(() => {
      const nextSlideIndex = containerRef.current?.querySelector('.swiper-slide-next')?.getAttribute('data-swiper-slide-index');
      if (nextSlideIndex !== void 0) {
        store.nextTitle = layerData.worldViewList[nextSlideIndex]?.world_part_title;
      }
    });
  };
  getNextTitle();

  const renderSwiper = () => {
    if (layerData.worldViewList.length) {
      return layerData.worldViewList.map((item, key) => {
        return (
          <div className={styles.worldPartItem} key={key}>
            <div className={styles.worldPartItemImgWrap}>
              <div className={styles.texture} />
              <div className={styles.worldPartItemImg} style={{ backgroundImage: `url(${item.img_url})` }} />
            </div>
            <div className={styles.worldPartInfo}>
              <div className={styles.infoTitle}>{item.world_part_title}</div>
              <div className={styles.infoSubTitle}>
                {/* {item.subTitle.trim() && <div className={styles.infoSubTitleContent}>{item.subTitle}</div>} */}
                <div data-btn="more" data-btn-hover style={{ backgroundImage: `url(${localData?.viewDetailBtn})` }} className={styles.knowMore} />
              </div>
            </div>
          </div>
        );
      });
    }
  };
  const handleClick = e => {
    const target = e.target;
    if (target.getAttribute('data-btn') !== 'more') {
      return;
    }
    store.toDetail();
  };
  return (
    <div className={cx(styles.worldRoot)}>
      <div ref={containerRef} className={styles.container} onClick={handleClick}>
        {layerData.worldViewList?.length > 0 && <BaseSwiper store={store.baseSwiperStore}>{renderSwiper()}</BaseSwiper>}
        <div className={styles.nextTipsContainer}>
          <div className={styles.nextContent}>{store.pageLocalesData.nextText}</div>
          <Link className={styles.nextTitle}>{store.nextTitle}</Link>
        </div>
        <Link className={styles.prevBtn} onClick={store.baseSwiperStore.goPrev} />
        <Link className={styles.nextBtn} onClick={store.baseSwiperStore.goNext} />
        <div className={styles.lightIcon} />
        <div className={styles.paginatorBox}>{renderPaginator()}</div>
        <div data-name="轮播布局区域模拟，处理”lightIcon“hover样式用" className={styles.swiperAreaSimulate} onClick={store.baseSwiperStore.goNext} />
        <div data-name="轮播分割光影" className={styles.lightIcon} />
      </div>
    </div>
  );
};

export default wrapStore(SeventhPage, SeventhPageStore);
